import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';

import objectToFormData from 'object-to-formdata';


//window.ssoForetag = window.ssoForetag || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiMermeny,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	methods: {

		// Denna genererar mermenyn för ett (1) enskilt bestämt företag:
		menyConfigForEttForetag(foretagId, name)
		{
			const mc = new euiPopUpMenyClasses.menyConfig([
					new euiPopUpMenyClasses.delEvent('Ta bort', 'taBortForetag', {
						ikon: 'taBort',
						cssModifierClass: '-fara',
						eventData: {
								foretagId,
								name,
							},
					}),
				]);

			return mc;
		},

		//======================================================================================================================================

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'taBortForetag':
					{
						// eventData:
						//foretagId: foretag.ForetagId,
						//name: foretag.Name,



						// Todo: Ändra?
						//	+ '<p>Alla användare som har åtkomst till företaget förlorar den efter en tid och kan behöva bjudas in på nytt om företaget åter laddas upp.</p>'




						this.visaMeddelande(
							'<p>Är du säker på att du vill ta bort företaget '
							+ `<b>${eventData.name}</b> `
							+ 'från Siffersurfaren Online?</p>'
							+ '<p>Alla användare som har åtkomst till företaget förlorar den och kan behöva bjudas in på nytt om företaget åter laddas upp.</p>'
							, {
								dialogId: 'taBortForetagBekraftelse',
								ikon: 'fragemeddelande',
								ikonCssModifierClass: '-info',
								knappar: [
										new euiDialogClasses.knappAvbryt(),
										new euiDialogClasses.knappEvent('Ta bort företaget', 'taBortForetagBekraftad', { eventData: eventData.foretagId }),
									],
								//breddMedEnhet: '36rem',	// Default = '36rem'.
							}
						);

						break;
					}
			}
		},

		onKnappTrycktIMeddelandedialog({ eventId, eventData })
		{
			switch (eventId) {
				case 'taBortForetagBekraftad':
					{
						const foretagId = eventData;	// För tydlighet.

						this.AjaxpostaOchHanteraResultat('/installningar/foretag-delete', {
							formData: objectToFormData({ foretagId: foretagId }),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

								// Todo: Laddar om hela sidan så att de nya datana slår igenom. Detta är egentligen ett korkat och omodernt och klumpigt sätt att göra det på, men:
								window.location.reload(true);
							},
						});

						break;
					}
			}
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	mounted()
	{
		// Programmatisk bind:
		this.$on('knapp-tryckt-i-meddelandedialog', this.onKnappTrycktIMeddelandedialog);
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

// Görs nu i ssoAllaSidorMixin:
//console.time('#TIMING: initieraTooltips');	// Todo: TEMP!!!
//ssoTooltips.initiera(document.body);
//console.timeEnd('#TIMING: initieraTooltips');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;


